class ApplyNowBoxComponent extends HTMLElement {
  constructor() {
    super();
    this.mainBox = this.querySelector('.apply-now-box-block');
    this.stickyBox = this.querySelector('[data-sticky-box]');
    
    if (!this.mainBox || !this.stickyBox) return;

    this.initObserver();
  }

  initObserver() {
    if (window.innerWidth >= 750) return;
    this.stickyBox.classList.add('is-visible');

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.stickyBox.classList.remove('is-visible');
        } else {
          this.stickyBox.classList.add('is-visible');
        }
      });
    }, observerOptions);

    observer.observe(this.mainBox);
  }
}

customElements.define('apply-now-box-component', ApplyNowBoxComponent);

const sections = document.querySelectorAll('.product-information__grid');
sections.forEach(function(section) {
  const popup = section.querySelector('.apply-now-box__popup');
  if (!popup) return;
  const containID = popup.getAttribute('data-popup-id');
  const popupTriggers = section.querySelectorAll(`.apply-now-box-button-button__trigger[data-popup-trigger="${containID}"]`);
  const popupCloses = popup.querySelectorAll('[data-popup-close]');
  const popupInner = popup.querySelector('.apply-now-box-popup__content');

  if (popup && popupTriggers) {
    popupTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        popup.setAttribute('open', '');
      });
    });

    if (!popupCloses.length) return;
    popupCloses.forEach(function(close) {
      close.addEventListener('click', function() {
        popup.removeAttribute('open');
      });
    });

    if (!popupInner) return;
    popup.addEventListener('click', function(e) {
      if (!popupInner.contains(e.target)) {
        popup.removeAttribute('open');
      }
    });

  }
});